import React from "react";
import { Link } from "react-router-dom";
import ConnectButton from "../ConnectWallet/ConnectButton";

function Navbar() {
  return (
    <nav className="navbar">
      <Link to="/home" className="navbar-brand" style={{ textDecoration: "none" }}>
        <div className="navbar-logo">
          <img src="/logo.png" alt="" onError={(e) => (e.currentTarget.style.display = "none")} />
        </div>
        <span className="navbar-brand-text">888 GLOBAL</span>
      </Link>
      <ConnectButton />
    </nav>
  );
}

export default Navbar;
